import React, { useEffect, useRef } from 'react';
import { API_URL } from '../../services/api';

const PanoramaViewer = ({ panoramaUrl, hotspots = [], containerId = 'panorama-viewer' }) => {
    const containerRef = useRef(null);
    const viewerRef = useRef(null);

    useEffect(() => {
        if (!panoramaUrl || !window.pannellum || !containerRef.current) return;

        if (viewerRef.current) {
            viewerRef.current.destroy();
        }

        const fullUrl = panoramaUrl.startsWith('/') ? `${API_URL}${panoramaUrl}` : panoramaUrl;

        viewerRef.current = window.pannellum.viewer(containerRef.current, {
            type: 'equirectangular',
            panorama: fullUrl,
            autoLoad: true,
            showControls: true,
            hotSpots: hotspots.map(h => ({
                pitch: 0,
                yaw: 0,
                type: 'info',
                text: h.label,
                clickHandlerFunc: h.onClick,
            })),
        });

        return () => {
            if (viewerRef.current) {
                viewerRef.current.destroy();
                viewerRef.current = null;
            }
        };
    }, [panoramaUrl, hotspots]);

    return (
        <div
            ref={containerRef}
            id={containerId}
            style={{ width: '100%', height: '500px', borderRadius: '8px', overflow: 'hidden' }}
        />
    );
};

export default PanoramaViewer;
